function initProductGallerySlider(gallery) { 
  const mainImages = gallery.querySelectorAll(".product-gallery-slider-media"); 
  const thumbs = gallery.querySelectorAll(".product-gallery-slider-thumb .thumb-image"); 
  const prevBtn = gallery.querySelector(".gallery-slider-arrow--prev"); 
  const nextBtn = gallery.querySelector(".gallery-slider-arrow--next"); 
  
  let currentIndex = 0; 
  
  function showImage(index) { 
    mainImages.forEach(img => img.classList.remove("active")); 
    thumbs.forEach(t => t.classList.remove("active")); 
    mainImages[index].classList.add("active"); 
    thumbs[index].classList.add("active"); currentIndex = index; 
  }

  // Init
  showImage(0);

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => showImage(index));
  });

  prevBtn.addEventListener("click", () => {
    let newIndex = currentIndex === 0 ? mainImages.length - 1 : currentIndex - 1;
    showImage(newIndex);
  });

  nextBtn.addEventListener("click", () => {
    let newIndex = currentIndex === mainImages.length - 1 ? 0 : currentIndex + 1;
    showImage(newIndex);
  });

  // --- Swipe support ---
  let startX = 0;
  let endX = 0;

  gallery.addEventListener("touchstart", e => {
    startX = e.touches[0].clientX;
  });

  gallery.addEventListener("touchmove", e => {
    endX = e.touches[0].clientX;
  });

  gallery.addEventListener("touchend", () => {
    let diff = startX - endX;
    if (Math.abs(diff) > 100) { 
      if (diff > 0) {
        // swipe left → next
        let newIndex = currentIndex === mainImages.length - 1 ? 0 : currentIndex + 1;
        showImage(newIndex);
      } else {
        // swipe right → prev
        let newIndex = currentIndex === 0 ? mainImages.length - 1 : currentIndex - 1;
        showImage(newIndex);
      }
    }
    startX = 0;
    endX = 0;
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-gallery-slider").forEach(initProductGallerySlider);
});
